module.exports = __webpack_public_path__ + "static/img/mulan-shop.79a5cd47.png";